import {
    Environment, Variant,
} from './index'

const releaseLabelPattern = /^[a-z0-9][a-z0-9._-]{0,47}$/u
const builtInVariants = new Set(['live', 'stage', 'unstable'])
const reservedLabels = new Set(['stage', 'unstable', 'new', 'app'])

export const isVersionedVariant = (variant?: Variant): boolean => variant !== undefined && !builtInVariants.has(variant)

export const isValidReleaseLabel = (label: unknown): label is string => typeof label === 'string' && releaseLabelPattern.test(label) &&
    !label.includes('..') && !label.endsWith('.') && !label.endsWith('.lock') && !reservedLabels.has(label)

const warnFallback = (label: string, reason: string): 'live' => {
    console.warn(`Ninchat deployment '${label}' is ${reason}; falling back to live.`)
    return 'live'
}

export const selectDeploymentVariant = async (requested: Variant | undefined, mode: Environment): Promise<Variant | undefined> => {
    if (!isVersionedVariant(requested)) {
        return requested
    }

    const label = requested as string
    if (!isValidReleaseLabel(label)) {
        return warnFallback(label, 'invalid')
    }
    if (process.env.SUBDIR) {
        console.warn(`Ninchat deployment '${label}' is ignored because this build is pinned to '${process.env.SUBDIR}'.`)
        return requested
    }
    if (mode !== 'production') {
        console.warn(`Ninchat deployment '${label}' is ignored outside production; using local deployment URLs.`)
        return 'live'
    }

    const url = `https://ninchat.com/${label}/new/assets/ninchat-defaults.json`

    try {
        const response = await fetch(url, {
            cache: 'no-store',
            method: 'HEAD',
            redirect: 'manual',
        })
        if (response.status === 200 && (!response.url || response.url === url) && !response.redirected &&
            response.headers.get('content-type')?.toLowerCase()
                .includes('application/json')) {
            return label
        }
        return warnFallback(label, 'unavailable')
    } catch (_error) {
        return warnFallback(label, 'unverifiable')
    }
}
